import { spawn } from 'redux-saga/effects';

import UserSagas from '../user/sagas';
import EnclaveSagas from '../enclave/sagas';
import SourceSagas from '../source/sagas';
import WorkflowSagas from '../workflow/sagas';
import ArbiterSagas from '../arbiter/sagas';
import SafelistSagas from '../safelists/sagas';

export default function* rootSaga() {
  yield spawn(UserSagas);
  yield spawn(EnclaveSagas);
  yield spawn(SourceSagas);
  yield spawn(WorkflowSagas);
  yield spawn(ArbiterSagas);
  yield spawn(SafelistSagas);
}
